import React from 'react';
import { StyleSheet, type ViewProps } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { theme } from '@garnish/constants';

export const ScanToPayContainer = (props: ViewProps) => {
  return (
    <ScrollView contentContainerStyle={styles.container}>
      {props.children}
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: theme.spacing['4'],
    gap: theme.spacing['4'],
  },
});
